import {EventConstants} from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';

class RegistryStore extends Store {
  activeRegistryId!: string | null;

  override resetState(): void {
    this.activeRegistryId = null;
  }

  getActiveRegistryId(): string | null {
    return this.activeRegistryId;
  }

  override payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.REGISTRY_ACTIVATED: {
        const {registryId} = action;
        this.activeRegistryId = registryId;
        this.emitChange();
        break;
      }

      default:
        break;
    }
    return true;
  }
}

export default new RegistryStore(AppDispatcher);
